import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, NgModule } from '@angular/core';
import { NgxsModule, select } from '@ngxs/store';
import { AnimateModule, HeaderComponent, NewsletterComponent } from '@pro-connect/shared';
import { BasicPage, WwwAppState } from '../../../../models';
import { HomeAboutUsComponent } from './components/home-about-us/home-about-us.component';
import { HomePillarsComponent } from './components/home-pillars/home-pillars.component';
import { HomeTopComponent } from './components/home-top/home-top.component';
import { HomeState } from './home.state';
import { Angulartics2GoogleTagManager } from 'angulartics2';

@NgModule({
  imports: [NgxsModule.forFeature([HomeState])],
})
class HomeStateLazyModule {}

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    AnimateModule,
    HomeStateLazyModule,
    NewsletterComponent,
    HomeTopComponent,
    HomeAboutUsComponent,
    HomePillarsComponent,
    HeaderComponent,
  ],
})
export class HomeComponent extends BasicPage {
  public override readonly loading = select(HomeState.loading);
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  constructor() {
    super();
  }

  public ngOnInit(): void {
    this._pushLayer(!!this.user(), 'pl', 'PL');
  }

  private _pushLayer(isLogged: boolean, language: string, country: string): void {
    this._angulartics2GoogleTagManager.pushLayer({
      brand: 'LDB',
      language: language,
      country: country,
      siteTypeLevel: this._isDevelopment ? 'test' : 'main',
      pageCategory: 'homepage',
      geoIPLocation: country,
      uiLoggedStatus: isLogged ? 'logged' : 'not logged',
      uiType: this.user()?.type,
    });
  }
}
